import { Outlet, createFileRoute } from '@tanstack/react-router'

import { listSpacesOptions } from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute('/_auth/$companyId/spaces/$spaceId')({
  component: () => <Outlet />,
  loader: async ({
    context: { queryClient },
    params: { spaceId, companyId },
  }) => {
    const spaces = await queryClient.ensureQueryData(
      listSpacesOptions({
        path: {
          companyID: companyId,
        },
      }),
    )

    const items = (spaces.items as typeof spaces.items | null) ?? []
    const space = items.find(({ id }) => id === spaceId)

    return {
      breadcrumbTitle: space?.name || '',
      breadcrumbPath: `/${companyId}/spaces/${spaceId}/projects`,
    }
  },
})
